import script from "./CartCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartCell.vue?vue&type=script&setup=true&lang=ts"

import "./CartCell.vue?vue&type=style&index=0&id=1601474a&scoped=true&lang=css"

import exportComponent from "/srv/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1601474a"]])

export default __exports__